import {useNavigate} from 'react-router-dom';
import {useCallback} from "react";
import {AuthorizeParameters} from "../../../models/AuthorizeParameters";
import {formatSignInParametersAsQueryString} from "../utils";

export function useRedirectToApproval(signInParameters: AuthorizeParameters): () => void {
    const navigate = useNavigate();
    return useCallback(() => {
        navigate(`/approve?${formatSignInParametersAsQueryString(signInParameters)}`);
    }, [navigate, signInParameters]);
}
